// import { store } from "@/vuex/store.js"ž
import {signOut} from "@/services/auth/redirectLogin"

var timeout = setTimeout(function () { }, 0);
const minutest_log_timer = 640
const timeout_seconds = minutest_log_timer * 60;
const final_time = timeout_seconds * 1000;

var refreshLogoutTimer =  function(){
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setTimeout(() => {
      location.reload(true);
      }, 2000);
      signOut();
      }, final_time);
}

export {
   refreshLogoutTimer
}